import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import _get from 'lodash/get'

// State Selectors
import * as fromProjectsSelectors from '../../stores/ducks/projects/selectors'
import * as fromCombinationsSelectors from '../../stores/ducks/combinations/selectors'
import { getTempTitle } from '../../stores/ducks/scenes/selectors'
import { getIsDirty } from '../../stores/ducks/dirty/selectors'
import * as fromThreeviewerFilesSelectors from '../../stores/ducks/threeviewer/files/selectors'
import { statuses as projectStatuses } from '../../stores/ducks/projects'

// JSX Components : Layout
import Header from '../layout/header'
import { RootState } from '../../stores/ducks'

const DEFAULT_TITLE = 'Unsaved'

type Props = {
  onBeforeNavigate: () => void
}

const resolveImagePackageTitle = (currentCombination: any, parentCombinationTitle: any) => {
  const currentCombinationTitle = currentCombination.isMaster ? 'Master scene' : currentCombination.title
  return parentCombinationTitle ? `${parentCombinationTitle}: ${currentCombinationTitle}` : DEFAULT_TITLE
}

const mapStateToProps = createSelector(
  fromProjectsSelectors.getCurrentEntry,
  fromProjectsSelectors.getStatus,
  fromCombinationsSelectors.getCurrentEntry,
  fromCombinationsSelectors.getEntries,
  (_: RootState, ownProps: Props) => ownProps.onBeforeNavigate,
  getTempTitle,
  getIsDirty,
  fromThreeviewerFilesSelectors.getIsLoading,
  (currentProject, projectStatus, currentCombination, combinations, onBeforeNavigate, tempTitle, isDirty, isSceneLoading) => {
    const isProjectReady = projectStatus === projectStatuses.FETCHED
    const isImagePackageProject = currentCombination.imagePackageId

    if (!isProjectReady) {
      return { breadcrumbs: [], isImagePackageProject }
    }

    const dirtyPrefix = isDirty && isProjectReady && !isSceneLoading ? '* ' : ''
    let breadcrumbs

    if (isImagePackageProject) {
      const parentCombinationTitle = _get(combinations, [currentCombination.parentId, 'title'])
      const imagePackageTitle = resolveImagePackageTitle(currentCombination, parentCombinationTitle)
      breadcrumbs = [
        {
          id: 0,
          route: `/image-package-project/${currentProject.id}/show`,
          title: currentProject.title,
          onBeforeNavigate,
          hardLink: false
        },
        {
          id: 1,
          title: dirtyPrefix + imagePackageTitle
        }
      ]
    } else {
      breadcrumbs = [
        {
          id: 0,
          route: `/project/${currentProject.id}/show`,
          title: currentProject.title,
          onBeforeNavigate,
          hardLink: false
        },
        {
          id: 1,
          title: dirtyPrefix + (tempTitle ?? DEFAULT_TITLE)
        }
      ]
    }

    return {
      breadcrumbs,
      isImagePackageProject
    }
  }
)

export default connect(
  mapStateToProps
)(Header)
